module.exports = __webpack_public_path__ + "img/NP.d8ed23e6.svg";